<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <span class="app-name">Служба технической поддержки: 8 (495) 417-12-09 доб. 313/349, helpcms@zdrav.mos.ru</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
    mounted() {
        // Проверяем, не загружен ли уже счётчик
        if (typeof window.ym !== 'undefined') {
            return;
        }

        // Создаём и вставляем скрипт Яндекс.Метрики
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.textContent = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

      ym(56379670, 'init', {
        webvisor: true,
        trackHash: true,
        clickmap: true,
        accurateTrackBounce: true,
        trackLinks: true
      });
    `;
        document.head.appendChild(script);
    },
};
</script>

<style lang="scss">
.layout-footer .footer-logo-container .app-name {
    font-family: Helvetica Neue, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #949494;
}
</style>
